<div *ngIf="player.fullscreen || (player && alwaysOn)" class="analysisControls">
  <button
    mat-icon-button
    [matTooltip]="'cameras.stream.tooltips.showDetectionOutlines' | t"
    class="show-events-button"
    *ngIf="player.live && player.local &&
    camera.liveVideoUrls.main?.local?.wssEvents"
    [class.yellow-text]="player.showEvents"
    (click)="player.showEvents = !player.showEvents"
  >
    <i class="fa-light fa-square-user"></i>
  </button>
  <sn-icon-button [matTooltip]="'common.videoPlayer.backFiveSeconds' | t" (click)="back(5)">
    <sn-icon size="md">replay_5</sn-icon>
  </sn-icon-button>
  <sn-icon-button [matTooltip]="'cameras.stream.tooltips.backOneFrame' | t" (click)="framesBack()">
    <sn-icon class="fa-solid fa-backward-step" size="md"></sn-icon>
  </sn-icon-button>
  <sn-icon-button [matTooltip]="'common.videoPlayer.rewind' | t" (click)="rewind()" (mousedown)="$event.preventDefault()">
    <sn-icon size="md">fast_rewind</sn-icon>
  </sn-icon-button>
  <sn-player-play-control *ngIf="!isRewinding"></sn-player-play-control>
  <sn-icon-button [matTooltip]="'common.videoPlayer.pause' | t" *ngIf="isRewinding" (click)="pauseRewind()">
    <sn-icon size="md">pause</sn-icon>
  </sn-icon-button>
  <sn-icon-button
    [class.disabledBtn]="player.live"
    [disabled]="player.live"
    [matTooltip]="'common.videoPlayer.fastForward' | t"
    (click)="fastForward()"
    (mousedown)="$event.preventDefault()"
  >
    <sn-icon size="md">fast_forward</sn-icon>
  </sn-icon-button>
  <sn-icon-button
    [class.disabledBtn]="player.live"
    [disabled]="player.live"
    [matTooltip]="'cameras.stream.tooltips.forwardOneFrame' | t"
    class="forwardButton"
    (click)="framesForward()"
  >
    <sn-icon class="fa-solid fa-forward-step" size="md"></sn-icon>
  </sn-icon-button>
  <sn-icon-button
    [class.disabledBtn]="player.live"
    [disabled]="player.live"
    [matTooltip]="'common.videoPlayer.forwardFiveSeconds' | t"
    (click)="forward(5)"
  >
    <sn-icon size="md">forward_5</sn-icon>
  </sn-icon-button>
  <sn-icon-button [matTooltip]="'cameras.stream.tooltips.screenshotVideo' | t" (click)="clip()">
    <sn-icon size="md">content_cut</sn-icon>
  </sn-icon-button>
  <!-- TODO : For calendar work https://taserintl.atlassian.net/browse/FWX-3070 -->
  <sn-icon-button
    [matTooltip]="'cameras.stream.tooltips.toggleCalendar' | t"
    (click)="toggleCalendar.next(showCalendar)"
    *ngIf="camera.record || camera.playbackUrls"
  >
    <sn-icon size="md">date_range</sn-icon>
  </sn-icon-button>
  <sn-icon-button
    [matTooltip]="'cameras.stream.tooltips.createClip' | t"
    (click)="openClipControl()"
    [disabled]="this.camera.make === 'Eagle Eye Networks'"
    *ngIf="showClipControl()"
  >
    <sn-icon size="md">theaters</sn-icon>
  </sn-icon-button>
  <sn-icon-button
    class="home-button"
    *ngIf="camera?.geometry?.coordinates && defaultMapSource !== 'esri'"
    (click)="enterStreetView()"
    [matTooltip]="'cameras.stream.tooltips.enterStreetView' | t"
    matTooltipPosition="above"
  >
    <sn-icon size="md" fontSet="fal" fontIcon="fa-street-view"></sn-icon>
  </sn-icon-button>
  <div class="fs__playback-rate-container">
    <ng-container
      *ngIf="(isFastForwarding && playbackRate > 1) || (isRewinding && rewindSpeedFactor > 0)"
    >
      <div class="playbackRate" [class.forward]="isFastForwarding" [class.rewind]="isRewinding">
        <sn-icon class="fs-mr-1" *ngIf="isRewinding" size="md">fast_rewind</sn-icon>
        <sn-icon class="fs-mr-1" *ngIf="isFastForwarding" size="md">fast_forward</sn-icon>
        <span
          >x
          <ng-container *ngIf="isFastForwarding">{{ playbackRate }}</ng-container>
          <ng-container *ngIf="isRewinding">{{ rewindSpeedFactor }}</ng-container></span
        >
      </div>
    </ng-container>
    <div class="bufferLoadingWrapper" *ngIf="isBuffering">
      <mat-spinner
        class="bufferLoadingSpinner fs-mr-2"
        diameter="32"
        color="accent"
        mode="indeterminate"
      ></mat-spinner>
      <span class="bufferLoadingMsg">{{ 'cameras.stream.messages.buffering' | t }}</span>
    </div>
  </div>
</div>
